module.exports = __webpack_public_path__ + "img/ic-resumo-mensal.9b14e1b2.png";